// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-dashboard a {
  height: 100%;
}
.welcome-dashboard a .dashboard-card {
  height: 100%;
}
.welcome-dashboard a .dashboard-card span.anticon,
.welcome-dashboard a .dashboard-card .ant-card-meta-title {
  color: #1890ff;
}
.welcome-dashboard .ant-card-meta-avatar span.anticon {
  font-size: 2em;
}
.welcome-dashboard .ant-card.statistics-dashboard-card .dashboard-card-body {
  padding: 10px;
}
.welcome-dashboard .ant-card .ant-table-placeholder {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Component/WelcomeDashboard/WelcomeDashboard.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;AAAJ;AAFA;EAKM,YAAA;AAAN;AALA;;EAQQ,cAAA;AACR;AATA;EAeM,cAAA;AAHN;AAQI;EAEI,aAAA;AAPR;AAfA;EA2BM,aAAA;AATN","sourcesContent":[".welcome-dashboard {\n  a {\n    height: 100%;\n\n    .dashboard-card {\n      height: 100%;\n\n      span.anticon, .ant-card-meta-title {\n        color: #1890ff;\n      }\n    }\n  }\n\n  .ant-card-meta-avatar {\n    span.anticon {\n      font-size: 2em;\n    }\n  }\n\n  .ant-card {\n    &.statistics-dashboard-card {\n      .dashboard-card-body {\n        padding: 10px;\n      }\n    }\n\n    .ant-table-placeholder {\n      display: none;\n    }\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
